import { useTranslation } from 'react-i18next';
import ReactPaginate from 'react-paginate';
import { useSelector } from 'react-redux';

import type { RootState } from 'redux/store';

interface PaginatedItemsProps {
    itemsPerPage: number;
    numberOfItems: number;
    handleClick: (page: number) => void;
    pageNumber: number;
}

export function PaginatedItems({
    itemsPerPage,
    numberOfItems,
    handleClick,
    pageNumber,
}: PaginatedItemsProps) {
    const { language_setting: language } = useSelector((state: RootState) => state.user.entity);
    const { t } = useTranslation();
    if (numberOfItems <= 0 || itemsPerPage <= 0) return null;

    const pageCount = Math.ceil(numberOfItems / itemsPerPage);

    const handlePageClick = (event: { selected: number }) => {
        handleClick(event.selected + 1);
    };

    return (
        <div>
            <ReactPaginate
                nextLabel={`${t('next', { lng: language })} >`}
                onPageChange={handlePageClick}
                pageRangeDisplayed={3}
                marginPagesDisplayed={2}
                pageCount={pageCount}
                previousLabel={`< ${t('previous', { lng: language })}`}
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link"
                nextClassName="page-item"
                nextLinkClassName="page-link"
                breakLabel="..."
                breakClassName="page-item"
                breakLinkClassName="page-link"
                containerClassName="pagination"
                activeClassName="active"
                renderOnZeroPageCount={null}
                forcePage={pageNumber - 1}
            />
        </div>
    );
}
